import { Button } from "components/Button/Button"
import { BaseLayout } from "components/BaseLayout/BaseLayout"
import { Empty } from "components/Empty/Empty"
import { UnauthorizedIcon } from "icons/UnauthorizedIcon"

export const SessionExpired = () => {
	return (
		<BaseLayout className="lg:grid-cols-1">
			<BaseLayout.Header visibleHelpItems={false} username="" />

			<BaseLayout.Main>
				<Empty
					Icon={UnauthorizedIcon}
					title="Session has expired"
					description="Your session is no longer valid."
				>
					<Button
						size="large"
						onClick={() => {
							window.location.href = "/login"
						}}
					>
						Sign in again
					</Button>
				</Empty>
			</BaseLayout.Main>
		</BaseLayout>
	)
}
